import { BCMSRecord, ModalOpen, useBCMSContext, useBCMSModal, useParams, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UITextInput from "components/ui/UITextInput";
import { getDefault, getWorkflowSteps } from "components/workflows/BalanceTransferWorkflow";
import { Card } from "model";
import React, { useState } from "react";
import "./styles.css";

/**
 * @function TransferRecipientInfoView
 * @return {React.Component}
 * @exported true
 * @description The main component for TransferRecipientInfoView
 */
export default function TransferRecipientInfoView(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ], globalController);
  const cardID = useParams().cardID ?? "0";
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const state = workflowStep.getStepState;
  const [ value, setValue ] = useState({...state});
  let inputValuesAreFilled = true;

  // Check if parts of the form are filled.
  for (let prop in value) {
    if(prop === "fi" || prop === "fiAddress" || prop === "city"
    || prop === "state" || prop === "zip") {
      if(value[prop] === "") {
        inputValuesAreFilled = false;
        break;
      }
     }
  }

  const inputChange = prop => val => {
    // Do not allow more than 2 characters for a "state", like "NE" or "CA".
    if(prop === "state" && val.length > 2) { return; }
    setValue({...value, [prop]: val});
  }
  const next = evt => {
    workflowStep.update([ "fi" ], value.fi);
    workflowStep.update([ "fiAddress" ], value.fiAddress);
    workflowStep.update([ "city" ], value.city);
    workflowStep.update([ "state" ], value.state);
    workflowStep.update([ "zip" ], value.zip);
    workflowStep.workflow.nextStep();
  }

  const navigate = useRoute();
  const { close } = useBCMSModal();
  const yesClicked = () => {
    close("CancelBalanceTransferModal");
    navigate(-3);
  }

  return (
    <div className="transfer-recipient-info-view">
      <div className="content-container">
          <p>Enter the name and payment address of the financial institution for which you will be transferring the balance.</p>
      </div>
      <FormContainer>
        <FormRow>
          <UITextInput value={ value.fi } placeholder="Financial institution*" onChange={ inputChange("fi") } />
        </FormRow>
        <FormRow>
          <UITextInput value={ value.fiAddress } placeholder="Financial institution address*" onChange={ inputChange("fiAddress") } />
        </FormRow>
        <FormRow>
          <UITextInput value={ value.city } placeholder="City*" onChange={ inputChange("city") } />
        </FormRow>
        <FormRow>
          <UITextInput value={ value.state } placeholder="State*" onChange={ inputChange("state") } />
        </FormRow>
        <FormRow>
          <UITextInput value={ value.zip } placeholder="Zip code*" onChange={ inputChange("zip") }/>
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Next" className={ inputValuesAreFilled ? "" : "disabled" } onClick={ next } />
          <ModalOpen id="CancelBalanceTransferModal" data= { {yesClicked: yesClicked} }>
            <UICancelButton text="Cancel" />
          </ModalOpen>
        </FormButtonContainer>
      </FormContainer>
    </div>
  )
}
